import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from "angularfire2/firestore";
import { Observable } from "rxjs";
import { map, first } from 'rxjs/operators';
import * as firebase from "firebase/app";
import * as moment from "moment";

import { IDistrict } from "../../interfaces/districts";

@Injectable()
export class DistrictsProvider {
  constructor(private db: AngularFirestore) {}

  getDistrict(districtId: string): Observable<IDistrict> {
    return this.db.doc<IDistrict>(`districts/${districtId}`).valueChanges();
  }

  getDistrictPromise(districtId: string): Promise<IDistrict> {
    return this.db
      .doc<IDistrict>(`districts/${districtId}`)
      .valueChanges()
      .pipe(first())
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/providers/districts/districts.ts